import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const RegistryRoutes: RouteBundle = {
  domain: 'registry',
  routes: [
    {urlPattern: 'registries/', handler: EditorRoutes.registries.bind(EditorRoutes), legacy: true},
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/general/',
      handler: EditorRoutes.registryGeneralSettings.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/',
      handler: EditorRoutes.tagSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/create',
      handler: EditorRoutes.tagSchemaCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/:tagSchemaId',
      handler: tagSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/tag-schemas/:tagSchemaId/:section',
      handler: tagSchemaSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/',
      handler: EditorRoutes.schemaFieldSelectors.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/create',
      handler: EditorRoutes.createSchemaFieldSelector.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/dropdowns/:selectorId',
      handler: EditorRoutes.schemaFieldSelector.bind(EditorRoutes),
      legacy: true,
    },
  ],
};

function tagSchemaSettings(
  ownerUrlId: string,
  registryId: string,
  tagSchemaId: string,
  section?: string
): void {
  EditorRoutes.tagSchemaSettings(ownerUrlId, registryId, tagSchemaId, section);
}
